"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPassengerFromPattern = void 0;
var moment_1 = __importDefault(require("@ambler/moment"));
var weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
var places = {
    A: {
        id: 'A',
        mainText: '104 rue du bac',
        secondaryText: '75010, Paris',
        address: { id: '', lat: 0, lng: 0, city: 'Paris' },
    },
    B: {
        id: 'B',
        mainText: '42 rue des geeks',
        secondaryText: '42000, Strasbourg',
        address: { id: '', lat: 0, lng: 0, city: 'Strasbourg' },
    },
    C: {
        id: 'C',
        mainText: '21 rue des alpes',
        secondaryText: '38000, Grenoble',
        address: { id: '', lat: 0, lng: 0, city: 'Grenoble' },
    },
    D: {
        id: 'D',
        mainText: '1 avenue des champs',
        secondaryText: '75008, Paris',
        address: { id: '', lat: 0, lng: 0, city: 'Paris' },
    },
};
var patients = {
    P1: { id: 'P1', firstname: 'Victoria', lastname: 'Hérouard', gender: 'FEMALE', birthdate: null },
    P2: { id: 'P2', firstname: 'Nicolas', lastname: 'Barray', gender: 'MALE', birthdate: '02/05/1987' },
    P3: { id: 'P3', firstname: 'Isabelle', lastname: 'Deschamps', gender: 'FEMALE', birthdate: '14/10/1998' },
};
// This is just a helper function to create a Passenger from a string.
// The goal is to make the tests more compact and easier to read.
// e.g: "P1 A -> B" will create {patientId: 'P1', direction: 'OUTBOUND', originId: 'A', destinationId: 'B'}
// e.g: "P2 A <- B" will create {patientId: 'P2', direction: 'INBOUND', originId: 'B', destinationId: 'A'}
var createPassengerFromPattern = function (pattern) {
    var _a = pattern.split(' '), patientId = _a[0], placeId1 = _a[1], arrow = _a[2], placeId2 = _a[3], day = _a[4], hour = _a[5], minute = _a[6];
    var originId = (arrow === '->' ? placeId1 : placeId2);
    var destinationId = (arrow === '->' ? placeId2 : placeId1);
    var _b = (function () {
        var _a;
        var base = (0, moment_1.default)('2026-01-13')
            .tz('Europe/Paris')
            .startOf('isoWeek')
            .add(1, 'week')
            .isoWeekday(weekdays.indexOf((_a = day) !== null && _a !== void 0 ? _a : 'monday') + 1)
            .hour(parseInt(hour !== null && hour !== void 0 ? hour : '10'))
            .minute(parseInt(minute !== null && minute !== void 0 ? minute : '0'));
        if (arrow === '->') {
            return [base.clone().subtract(1, 'hour'), base];
        }
        else {
            return [base, base.clone().add(1, 'hour')];
        }
    })(), departureTime = _b[0], arrivalTime = _b[1];
    return {
        id: pattern,
        patientId: patientId,
        patient: patients[patientId],
        direction: arrow === '->' ? 'OUTBOUND' : 'INBOUND',
        originId: originId,
        destinationId: destinationId,
        estimatedDuration: 600,
        invoiceableDistance: 5000,
        departureTime: departureTime.toDate(),
        arrivalTime: arrivalTime.toDate(),
        origin: places[originId],
        originServiceRaw: 'Acceuil',
        destination: places[destinationId],
        destinationServiceRaw: 'Acceuil',
        requestedVehicle: 'VSL',
        status: 'DISPATCHING',
        timeReference: arrow === '->' ? 'ARRIVAL' : 'DEPARTURE',
        timezone: 'Europe/Paris',
        optimizationRequestRows: [],
        trip: { id: '123', assignedMt: null },
        patientCondition: [],
        specificNeeds: [],
        isAccompanied: false,
        transportReason: 'DC_CS',
        isSameMfdType: false,
        details: '',
        mfuNotes: '',
        otherPassenger: { id: '123' },
        mfu: {
            id: '123',
            customization: null,
        },
        preferredMt: null,
        payer: 'HPTL_A',
        driverEvents: [],
    };
};
exports.createPassengerFromPattern = createPassengerFromPattern;
//# sourceMappingURL=test-helpers.js.map